import { Zap } from "lucide-react";
import { CLASS_BG, CLASS_TEXT, DeltaTag, fmtNumber } from "./PerfSharedUI";

/** SLA card — showcases the 15-min compliance rate. */
export default function SlaCard({ data }) {
  const sla = data?.sla || {};
  const cls = data?.classifications?.sla_compliance || "unknown";
  return (
    <div className={`rounded-2xl border-2 p-6 ${CLASS_BG[cls]}`} data-testid="sla-card">
      <div className="flex items-start justify-between mb-3">
        <div>
          <div className="text-[10px] uppercase tracking-[0.25em] text-muted-foreground font-semibold">
            SLA · Primeiro contacto
          </div>
          <h3 className="font-display text-xl">≤ {sla.sla_limit_minutes || 15} minutos</h3>
        </div>
        <Zap className={`w-5 h-5 ${CLASS_TEXT[cls]}`} />
      </div>
      <div className="flex items-baseline gap-3">
        <div className={`font-display text-5xl leading-none ${CLASS_TEXT[cls]}`}>
          {(sla.compliance_pct || 0).toFixed(0)}%
        </div>
        <DeltaTag delta={data?.deltas?.sla_compliance} />
      </div>
      <div className="grid grid-cols-3 gap-2 mt-4 text-xs">
        <div>
          <div className="text-[9px] uppercase tracking-[0.1em] text-muted-foreground font-semibold">No prazo</div>
          <div className="font-semibold text-[hsl(var(--success))]">{fmtNumber(sla.leads_within_sla || 0)}</div>
        </div>
        <div>
          <div className="text-[9px] uppercase tracking-[0.1em] text-muted-foreground font-semibold">Fora prazo</div>
          <div className="font-semibold text-[hsl(var(--warning))]">{fmtNumber(sla.leads_outside_sla || 0)}</div>
        </div>
        <div>
          <div className="text-[9px] uppercase tracking-[0.1em] text-muted-foreground font-semibold">Sem tratamento</div>
          <div className="font-semibold text-[hsl(var(--danger))]">{fmtNumber(sla.leads_untouched || 0)}</div>
        </div>
      </div>
      {sla.avg_response_minutes !== null && sla.avg_response_minutes !== undefined && (
        <div className="mt-3 text-xs text-muted-foreground">
          Tempo médio: <strong className="text-foreground">{sla.avg_response_minutes} min</strong>
          {" · "}Mediana: <strong className="text-foreground">{sla.median_response_minutes} min</strong>
        </div>
      )}
    </div>
  );
}
